import { BankContactForm } from '@/shared/lib/forms/contacts/bank';
import { BrokerContactForm } from '@/shared/lib/forms/contacts/broker';
import { IndividualContactForm } from '@/shared/lib/forms/contacts/individual';
import { LegalEntityContactForm } from '@/shared/lib/forms/contacts/legal-entity';
import { TDtoWrapper } from '@/shared/lib/forms/form-wrapper.types';
import { CollectionName } from '@/shared/lib/sj-orm/constants';
import { getCollectionDtoIdPrefix } from '@/shared/lib/sj-orm/helpers';
import { BaseDto, DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { ContactDto, ContactType } from '@/shared/lib/sj-orm/models/contact.dto';
/**
 *  @deprecated Use src/entities/contact/hooks/useI18nValues.ts
 */
export const ContactCategoryToText: Record<ContactType, string> = {
  [ContactType.INDIVIDUAL]: 'contacts:contactType.individual',
  [ContactType.LEGAL_ENTITY]: 'contacts:contactType.legalEntity',
  [ContactType.BANK]: 'contacts:contactType.bank',
  [ContactType.BROKER]: 'contacts:contactType.broker',
};

type OmittedBaseDto = Omit<BaseDto, 'id'>;

export const ContactsForms: Record<
  ContactType,
  TDtoWrapper<OmittedBaseDto, NonNullable<unknown>> | null
> = {
  [ContactType.INDIVIDUAL]: IndividualContactForm,
  [ContactType.LEGAL_ENTITY]: LegalEntityContactForm,
  [ContactType.BANK]: BankContactForm,
  [ContactType.BROKER]: BrokerContactForm,
};

export const isContactDtoId = (id: DtoId) => {
  return id.startsWith(getCollectionDtoIdPrefix(CollectionName.CONTACTS));
};

export const isContactDto = (dto: { id: string }): dto is ContactDto => {
  return typeof dto.id === 'string' && isContactDtoId(dto.id);
};
